import { render, staticRenderFns } from "./PickupDispatchCar.vue?vue&type=template&id=6f7b289a&scoped=true&"
import script from "./PickupDispatchCar.vue?vue&type=script&lang=js&"
export * from "./PickupDispatchCar.vue?vue&type=script&lang=js&"
import style0 from "./PickupDispatchCar.vue?vue&type=style&index=0&id=6f7b289a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7b289a",
  null
  
)

export default component.exports